import { useState } from 'react'
import { useItems } from '@/hooks/useItems'

export default function Home() {
  const { items, loading, error, createItem, removeItem } = useItems()
  const [name, setName]               = useState('')
  const [description, setDescription] = useState('')
  const [saving, setSaving]           = useState(false)

  async function handleSubmit(e) {
    e.preventDefault()
    if (!name.trim()) return
    setSaving(true)
    try {
      await createItem({ name: name.trim(), description: description.trim() })
      setName('')
      setDescription('')
    } catch (err) {
      alert(`Error: ${err.message}`)
    } finally {
      setSaving(false)
    }
  }

  return (
    <main className="container">
      <h1>Mi Webapp</h1>
      <p className="subtitle">React · Vite · Cloudflare Pages · D1</p>

      {/* ── Formulario ── */}
      <section className="card">
        <h2>Nuevo ítem</h2>
        <form onSubmit={handleSubmit} className="form">
          <input
            type="text"
            placeholder="Nombre *"
            value={name}
            onChange={e => setName(e.target.value)}
            required
          />
          <input
            type="text"
            placeholder="Descripción (opcional)"
            value={description}
            onChange={e => setDescription(e.target.value)}
          />
          <button type="submit" disabled={saving || !name.trim()}>
            {saving ? 'Guardando…' : 'Agregar'}
          </button>
        </form>
      </section>

      {/* ── Lista ── */}
      <section className="card">
        <h2>Ítems</h2>
        {loading && <p className="muted">Cargando…</p>}
        {error   && <p className="error">Error: {error}</p>}
        {!loading && !error && items.length === 0 && (
          <p className="muted">Todavía no hay ítems. ¡Agregá uno!</p>
        )}
        <ul className="item-list">
          {items.map(item => (
            <li key={item.id} className="item">
              <div>
                <strong>{item.name}</strong>
                {item.description && <span className="muted"> — {item.description}</span>}
              </div>
              <button
                className="btn-danger"
                onClick={() => removeItem(item.id)}
                aria-label={`Eliminar ${item.name}`}
              >
                ✕
              </button>
            </li>
          ))}
        </ul>
      </section>
    </main>
  )
}
